<template>
  <validated-form
    name="requestTwoFactorAuthPasscodeForm"
    @valid-submit="formSubmitHandler"
  >
    <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
      <Teleport
        defer
        to="#portal-modal-header-target"
      >
        Request Authentication Passcode
      </Teleport>

      <h1 class="cf-title cf-title--1">
        {{ title }}
      </h1>

      <p class="cf-subtitle cf-subtitle--2">
        {{ primarySubheader }}

        <br>

        {{ secondarySubheader }}
      </p>

      <cf-phone-number-input
        v-model="phoneNumber"
        label="Enter your phone number..."
        name="phoneNumber"
        :validations="{ required: true }"
      />

      <button
        :class="['cf-button cf-button--primary cf-button--lg', { 'cf-button--loading': isLoading }]"
        type="submit"
      >
        {{ submitCta }}
      </button>
    </div>
  </validated-form>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfPhoneNumberInput from '@/view/components/shared/cf-phone-number-input/index.vue';


  export default {
    name: 'RequestTwoFactorAuthPasscode',

    components: {
      CfPhoneNumberInput
    },

    props: {
      onSuccess: {
        type: Function,
        default: null
      }
    },

    data: () => ({
      phoneNumber: null,
      isLoading: false
    }),

    computed: {
      ...mapGetters('merchant', ['merchant']),

      title() {
        return 'Verify It\'s you';
      },

      primarySubheader() {
        return this.merchant.payAtTable2FA.triggerBeforeViewTicket
          ? 'Verify it\'s really you to view and pay for your bill.'
          : 'Verify it\'s really you to pay for your bill.';
      },

      secondarySubheader() {
        return 'We\'ll send you a text message with a code.';
      },

      submitCta() {
        return 'Send Code';
      }
    },

    methods: {
      async formSubmitHandler() {
        this.isLoading = true;

        const dispatchPayload = { contactInfo: this.phoneNumber, contactType: 'phoneNumber' };

        const { isSuccess } = await this.$store.dispatch('session/requestTwoFactorAuthPasscode', dispatchPayload);

        this.isLoading = false;

        if (isSuccess) {
          const twoFactorAuthModalPayload = { ...dispatchPayload, authType: 'phone-number-verification-required', onSuccess: this.onSuccess };

          this.$openModal('twoFactorAuthModal', twoFactorAuthModalPayload);
        }
      }
    }
  };
</script>
